module.exports = {};



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_iterators.js
// module id = 717
// module chunks = 27